import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { companies } from '../data/companies';
export function BrandFamily() {
  return <section className="py-24 px-6 md:px-10 bg-gray-50" data-id="element-43" data-mp="18hc3setnhakz">
      <div className="max-w-7xl mx-auto" data-id="element-44" data-mp="1dfdy5vwj0wbr">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16" data-id="element-45" data-mp="1decbeu65ele7">
          <div className="max-w-3xl" data-id="element-46" data-mp="fsnah1yu69js">
            <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-47" data-mp="ftq3bffpym2c">
              One family of companies
            </p>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-black" data-id="element-48" data-mp="pp9whu2wf6ne">
              We Develop. We Build. We Craft.
            </h2>
          </div>
          <Link to="/services" className="text-black hover:text-[#C5A55A] font-medium border-b-2 border-[#C5A55A] pb-1 transition-colors duration-200" data-id="element-49" data-mp="tpa7t5upb1q8">
            See all services
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-50" data-mp="1ppwq7air728x">
          {companies.map((company, index) => {
          const content = <>
                <h3 className="text-sm tracking-[0.2em] uppercase text-gray-500 mb-4" data-id="element-51" data-mp="1koqxhcp3feze">
                  {company.name}
                </h3>
                <p className="text-2xl md:text-3xl font-serif font-bold text-black mb-4" data-id="element-52" data-mp="1bqncchi0sk84">
                  {company.tagline}
                </p>
                <div className="mt-auto pt-4 flex items-center justify-between gap-4" data-id="element-53" data-mp="16svjnl9jwu2v">
                  <span className="text-gray-600" data-id="element-54" data-mp="11yrbwzsgoi0q">{company.role}</span>
                  {company.url && <ArrowUpRight className="w-5 h-5 text-[#C5A55A] shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-55" data-mp="wywl0w8orsfo" />}
                </div>
              </>;
          return <motion.div key={company.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-56" data-mp="9dcfbibe455z" data-mpi={index}>
                {company.url ? <a href={company.url} target="_blank" rel="noopener noreferrer" className="group flex flex-col h-full bg-white p-10 border-t-2 border-[#C5A55A] hover:shadow-xl transition-shadow duration-200" data-id="element-57" data-mp="s4lnno9fcnvz">
                    {content}
                  </a> : <div className="flex flex-col h-full bg-white p-10 border-t-2 border-[#C5A55A]" data-id="element-58" data-mp="1b265ibdrum73">
                    {content}
                  </div>}
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}